import { Controller } from "@hotwired/stimulus"

// Enables/disables the group contract reference field when the direct-distribution switch is off,
// so an unchecked box does not resubmit a previously stored reference (disabled inputs are omitted from the form).
export default class extends Controller {
  static targets = ["checkbox", "reference"]

  checkboxTargetConnected() {
    this.syncReferenceDisabled()
  }

  syncReferenceDisabled() {
    if (!this.hasReferenceTarget || !this.hasCheckboxTarget) return

    this.referenceTarget.disabled = !this.checkboxTarget.checked
  }
}
